// GTL Listing Section – Tab Switching & Hotspots
document.addEventListener('DOMContentLoaded', function () {
  var section = document.querySelector('.gtl-listing');
  if (!section) return;

  // --- Tab Switching ---
  var tabs = section.querySelectorAll('.gtl-listing__tab');
  var panels = section.querySelectorAll('.gtl-listing__panel');

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var targetTab = tab.getAttribute('data-tab');
      var tabLabel = tab.textContent.trim().toLowerCase();

      // Update active tab
      tabs.forEach(function (t) { t.classList.remove('is-active'); });
      tab.classList.add('is-active');

      // Update active panel
      panels.forEach(function (p) { p.classList.remove('is-active'); });
      var targetPanel = section.querySelector('[data-tab-panel="' + targetTab + '"]');
      if (targetPanel) {
        targetPanel.classList.add('is-active');
      }

      // Update URL ?tab= parameter without page reload
      var url = new URL(window.location.href);
      url.searchParams.set('tab', tabLabel);
      history.replaceState(null, '', url.pathname + url.search);
    });
  });

  // --- Hotspot Click → Scroll to Product ---
  var cards = section.querySelectorAll('.gtl-card');
  cards.forEach(function (card) {
    var slider = card.querySelector('.gtl-products-slider');
    if (!slider) return;

    var productCards = slider.querySelectorAll('.gtl-product-card');
    var hotspots = card.querySelectorAll('.gtl-hotspot');

    hotspots.forEach(function (hotspot) {
      hotspot.addEventListener('click', function (e) {
        e.preventDefault();
        var slideIndex = parseInt(hotspot.getAttribute('data-slide-index'), 10);
        if (!isNaN(slideIndex) && productCards[slideIndex]) {
          productCards[slideIndex].scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'start'
          });

          // Update active state
          hotspots.forEach(function (h) { h.classList.remove('is-active'); });
          hotspot.classList.add('is-active');
        }
      });
    });
  });

  // --- JS Fallback: Ensure correct tab is active based on URL ?tab= param ---
  // Liquid's content_for_header URL can be stale/cached, so we verify client-side.
  var urlParams = new URLSearchParams(window.location.search);
  var tabParam = urlParams.get('tab');

  if (tabParam && tabs.length > 0) {
    var tabParamLower = tabParam.trim().toLowerCase();
    var activeTab = section.querySelector('.gtl-listing__tab.is-active');
    var activeTabLabel = activeTab ? activeTab.textContent.trim().toLowerCase() : '';

    // If the currently active tab doesn't match the URL param, find and click the correct one
    if (activeTabLabel !== tabParamLower) {
      var correctTab = null;
      tabs.forEach(function (t) {
        if (t.textContent.trim().toLowerCase() === tabParamLower) {
          correctTab = t;
        }
      });

      if (correctTab) {
        correctTab.click();
      }
    }
  }
});
